import {
  faCode,
  faPaintBrush,
  faCalendarCheck,
} from "@fortawesome/free-solid-svg-icons";

export const staticServicesData = [
  {
    key: 0,
    icon: faCode,
    bgClass: "hover:bg-blue-50",
    color: "text-blue-600",
  },
  {
    key: 1,
    icon: faPaintBrush,
    bgClass:
      "hover:bg-gradient-to-br hover:from-pink-50 hover:via-purple-50 hover:to-blue-50",
    color: "text-green-600",
  },
  {
    key: 2,
    icon: faCalendarCheck,
    bgClass: "hover:bg-purple-50",
    color: "text-purple-600",
  },
];
